import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const MMCustomPaginator = ({ first, rows, totalRecords, onPageChange }) => {
  const totalPages = Math.ceil(totalRecords / rows);
  const currentPage = Math.floor(first / rows) + 1;

  const handlePrev = () => {
    if (currentPage > 1) {
      onPageChange({ first: first - rows, rows });
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange({ first: first + rows, rows });
    }
  };

  const handlePageClick = (page) => {
    onPageChange({ first: (page - 1) * rows, rows });
  };

  const renderPageNumbers = () => {
    const pages = [];
    const startPage = Math.max(currentPage - 2, 1);
    const endPage = Math.min(currentPage + 2, totalPages);

    for (let page = startPage; page <= endPage; page++) {
      pages.push(
        <span
          key={page}
          onClick={() => handlePageClick(page)}
          className={`paginator-page ${page === currentPage ? 'active' : ''}`}
        >
          {page}
        </span>
      );
    }

    return pages;
  };

  return (
    <div className="custom-paginator">
      <span
        onClick={handlePrev}
        className={`paginator-button ${currentPage === 1 ? 'disabled' : ''}`}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </span>
      {renderPageNumbers()}
      <span
        onClick={handleNext}
        className={`paginator-button ${currentPage === totalPages ? 'disabled' : ''}`}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </span>
    </div>
  );
};

export default MMCustomPaginator;
